import { render, staticRenderFns } from "./ProductConSwiper.vue?vue&type=template&id=713300aa&"
import script from "./ProductConSwiper.vue?vue&type=script&lang=js&"
export * from "./ProductConSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports